import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import usePageTracking from "./hooks/usePageTracking";
import './Admin.css';

// Pages
import CaseStudies from "./pages/public/CaseStudy";
import Contact from "./pages/public/Contact";

// Protected Routes
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLeads from "./pages/admin/AdminLeads";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminLeadDetail from "./pages/admin/AdminLeadDetail";
import AdminDashboard from "./pages/admin/AdminDashboard";
import Landing from "./pages/public/Landing";
import Commercial from "./pages/public/Commercial";
import Residential from "./pages/public/Residential";
import ResidentialRoofVisualizer from "./pages/public/ResidentialRoofVisualizer";
import Inspections from "./pages/public/Inspection";
import Fencing from "./pages/public/Fencing";
import DeckPatio from "./pages/public/DeckPatio";
import Siding from "./pages/public/Siding";
import InteriorRenovations from "./pages/public/InteriorRenovations";
import CaseStudyDetail from "./pages/public/Details";
import FaqHub from "./pages/public/FaqHub";
import FaqDetail from "./pages/public/FaqDetail";
import ReportPublic from "./pages/public/ReportPublic";
import AdminReportCreate from "./pages/admin/AdminReportCreate";
import AdminReportsList from "./pages/admin/AdminReportsList";
import AdminReportEdit from "./pages/admin/AdminReportEdit";
import AdminEstimatesList from "./pages/admin/AdminEstimatesList";
import AdminEstimateCreate from "./pages/admin/AdminEstimateCreate";
import EstimatePublicView from "./pages/public/EstimatePublicView";
import AdminEstimateEdit from "./pages/admin/AdminEstimateEdit";
import InvoicePublicView from "./pages/public/InvoicePublicView";
import AdminInvoices from "./pages/admin/AdminInvoices";
import AdminInvoiceEdit from "./pages/admin/AdminInvoiceEdit";
import AdminExpenses from "./pages/admin/AdminExpenses";


/**
 * This component exists ONLY to safely call usePageTracking()
 * inside Router context.
 */
function AnalyticsTracker() {
  usePageTracking();
  return null;
}

export default function App() {
  return (
    <Router>
      {/* Analytics MUST live here */}
      <AnalyticsTracker />

      <main>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/commercial" element={<Commercial />} />
          <Route path="/residential" element={<Residential />} />
          <Route path="/residential/roof-visualizer" element={<ResidentialRoofVisualizer />} />
          <Route path="/inspections" element={<Inspections />} />
          <Route path="/fencing" element={<Fencing />} />
          <Route path="/deck-patio" element={<DeckPatio />} />
          <Route path="/siding" element={<Siding />} />
          <Route path="/interior-renovations" element={<InteriorRenovations />} />
          <Route path="/portfolio" element={<CaseStudies />} />
          <Route path="/faq" element={<FaqHub />} />
          <Route path="/faq/:slug" element={<FaqDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path='/case-studies/:slug' element={<CaseStudyDetail />} />
          <Route path='/report/:blobId' element={<ReportPublic />} />
          <Route path='/estimate/:blobId' element={<EstimatePublicView />} />
          <Route path='/invoice/:blobId' element={<InvoicePublicView />} />

          {/* Fallback */}
          <Route
            path="*"
            element={
              <div style={{ padding: "4rem", textAlign: "center" }}>
                <h1>Page Not Found</h1>
                <p>The page you’re looking for doesn’t exist.</p>
              </div>
            }
          />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/leads"
            element={
              <ProtectedRoute>
                <AdminLeads />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/leads/:id"
            element={
              <ProtectedRoute>
                <AdminLeadDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/reports/new"
            element={
              <ProtectedRoute>
                <AdminReportCreate/>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/reports/edit/:blobId"
            element={
              <ProtectedRoute>
                <AdminReportEdit/>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/reports"
            element={
              <ProtectedRoute>
                <AdminReportsList/>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/estimates"
            element={
              <ProtectedRoute>
                <AdminEstimatesList/>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/estimates/new"
            element={
              <ProtectedRoute>
                <AdminEstimateCreate/>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/estimates/edit/:blobId"
            element={
              <ProtectedRoute>
                <AdminEstimateEdit/>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/expenses"
            element={
              <ProtectedRoute>
                <AdminExpenses />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/invoices"
            element={
              <ProtectedRoute>
                <AdminInvoices/>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/invoices/edit/:blobId"
            element={
              <ProtectedRoute>
                <AdminInvoiceEdit/>
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
    </Router>
  );
}
